import angular from 'angular';
import ConfigsModule from '../../configs/configs';
import ResourcesModule from '../../resources/resources';
import ServicesModule from '../../services/services';
import template from './analyticsEdit.jade';

export class AnalyticsEditController {
  /* @ngInject */
  constructor($rootScope,$stateParams,GamesResource,currentGame,$state,notify,$auth,Upload) {
    this.GamesResource = GamesResource;
    this.currentGame = currentGame;
    this.$state = $state;
    this.$rootScope = $rootScope;
    this.notify = notify;
    this.$auth = $auth;
    this.Upload = Upload;
    this.isResourceBeingPersisted = false;

    this.getGame($stateParams.gameId);
  }

  getGame(id) {
    this.GamesResource.one(id).get()
      .then((res) => {
        this.game = res;
        this.currentGame.onNext(this.game);
      })
  }

  update() {
    this.isResourceBeingPersisted = true;
    this.game.save()
      .then(() => {
        this.checkAndUploadLogoFile(this.game.id);
        this.notify.updated('app', this.game.name);
      })
      .catch(this.notify.apiError)
      .finally(() => {this.isResourceBeingPersisted = false});
  }

  checkAndUploadLogoFile(gameId) {
    if (this.logo) {
      this.Upload.upload({
        url: `/api/v1/games/${gameId}/logo_upload`,
        headers: {Authorization: 'Bearer ' + this.$auth.getToken(), 'Requested-From-Component': 'pepapi-frontend'},
        data: {file: this.logo}
      }).then((res) => {
        this.game.url = res.data.url;
        this.logo = null;
      })
    }
  }
}

export function AnalyticsEditComponent() {
  return {
    template,
    controller: AnalyticsEditController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {},
    bindToController: true
  };
};

export default angular.module('app.components.analytics.edit', [
  'toastr',
  'ngFileUpload',
  ConfigsModule.name,
  ResourcesModule.name,
  ServicesModule.name
])
.directive('analyticsEdit', AnalyticsEditComponent);



/** WEBPACK FOOTER **
 ** ./src/components/analytics/analyticsEdit.js
 **/